<template>
  <div id="app">
    <router-view></router-view> <!-- 必须有这一行，否则路由组件无法渲染 -->
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
</style>
